import { memo } from 'react';
import type { ContainerProps } from '@mui/material';
import { Container } from '@mui/material';

export interface MaxWidthContainerProps extends ContainerProps {}

const MaxWidthContainer: React.FC<MaxWidthContainerProps> = memo((props: MaxWidthContainerProps) => (
  <Container data-testid="maxWidthContainer" maxWidth="xl" {...props} />
));

export default MaxWidthContainer;
